import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {directusContext} from "./DirectusProvider";
import LoginForm from "../components/auth/LoginForm";
import Cours from "../components/cours/Cours";
import CoursEdit from "../components/cours/CoursEdit";
import {useContext} from "react";
import AcceptInvitation from "../components/auth/AcceptInvitation";
import ResetPassword from "../components/auth/ResetPassword";
import CoursVueEnsemble from "../components/cours/CoursVueEnsemble";

const AppRouter = ({children}) => {

    return (
        <BrowserRouter>
            {children}
            <Routes>
                <Route path={"/login"} element={<LoginForm/>}/>
                <Route path={"/accepter-invitation"} element={<AcceptInvitation/>}/>
                <Route path={"/reinitialiser-acces"} element={<ResetPassword/>}/>
                <Route
                    path="/cours/:id"
                    element={
                        <RequireAuth redirectTo="/login">
                            <CoursEdit/>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/cours"
                    element={
                        <RequireAuth redirectTo="/login">
                            <Cours historique={false}/>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/historique"
                    element={
                        <RequireAuth redirectTo="/login">
                            <Cours historique={true}/>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/vue-ensemble"
                    element={
                        <RequireAuth redirectTo="/login">
                            <CoursVueEnsemble/>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/*"
                    element={
                        <Navigate to="/cours"/>
                    }
                />
            </Routes>
        </BrowserRouter>
    );
};

const RequireAuth = ({children, redirectTo}) => {
    const {directus, currentUser} = useContext(directusContext);
    return directus.auth.token && currentUser ? children : <Navigate to={redirectTo}/>;
}

export default AppRouter;
